import React from "react";
import { Row, Col } from "react-bootstrap";

import { FORM_FIELD_KEYS } from "../../../../constants/forms";
import { getFieldProps } from "../../../../utils/form-fields";

import TextInput from "../../../controls/TextInput";

function SoleProprietorInfoBlock({ values = {}, onChange }) {
  return (
    <Row>
      <Col xs={12}>
        <div className="inputs-block-title">
          <span>Sole Proprietor Information</span>
        </div>
      </Col>
      <Col xs={12}>
        <TextInput
          {...getFieldProps(FORM_FIELD_KEYS.dbaname)}
          value={values[FORM_FIELD_KEYS.dbaname]}
          onChange={onChange}
        />
      </Col>
      <Col xs={12}>
        <div className="inputs-block-divider" />
      </Col>
    </Row>
  );
}

export default SoleProprietorInfoBlock;
